import React from "react";
import ContentBlock from "../../../components/molecules/contentBlock";

const LandingPage: React.FC = () => {
  return (
    <div className="font-rubik bg-black">
      {/* <LandingAnimateSplash /> */}
      <ContentBlock />
      {/* <LanguageSwitcher /> */}
      {/* <Footer /> */}
      {/* <ScrollToTopButton /> */}
    </div>
  );
};

export default LandingPage;
